import React from 'react';
import ReactDOM from 'react-dom';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import TagManager from 'react-gtm-module';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
process.env.REACT_APP_GTM_ID &&
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
  });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary withRouter={false}>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
